import { Box } from "@mui/material"
import React, {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useState,
} from "react"

import { s } from "../../utilities/common"
import { theme, TI } from "../../utilities/theme"
import { DGText } from "../common/DGText"

import { TeaserDimension, TeaserDimensions } from "./Slider"

export type LiveTitleRefProps = { setIndex: (index: number) => void }
export const LiveTabTitle = forwardRef<
  LiveTitleRefProps,
  { liveTitles: Record<number, string>; dimensions?: TeaserDimension }
>(({ liveTitles, dimensions }, ref) => {
  const [index, setIndex] = useState(0)
  useImperativeHandle(ref, () => ({
    setIndex: (t) => setIndex(t),
  }))
  const teaserDimensions = useMemo(
    () => (dimensions ? TeaserDimensions[dimensions] : undefined),
    [dimensions],
  )
  if (!teaserDimensions) return null
  return (
    <Box sx={{ height: s("123px"), width: "100%" }}>
      {Object.keys(liveTitles).map((key, i) => {
        const objectKeys = Object.keys(liveTitles)
        const keyNum = parseInt(key, 10)
        const calc =
          (keyNum - index) *
          (teaserDimensions.width + parseInt(teaserDimensions.colSpacing, 10))
        const ml =
          index > keyNum &&
          (objectKeys[i + 1] === undefined ||
            index < parseInt(objectKeys[i + 1], 10)) &&
          calc < 0
            ? 0
            : calc
        return (
          <DGText
            key={"livetab-titles" + i}
            tx={TI.H07tv}
            sx={{
              position: "absolute",
              transition: "0.2s ease-in-out",
              textTransform: "uppercase",
              color: theme.palette.white.main,
              pl: s("96px"),
              mb: s("64px"),
              willChange: "transform",
              transform: "translate3d(" + ml + "px, 0, 0)",
            }}
          >
            {liveTitles[keyNum]}
          </DGText>
        )
      })}
    </Box>
  )
})
